export default __webpack_public_path__ + "static/hub_long_logo-01-0efd65e73f78926bc3b7d115ded1f29d.png";